export default __webpack_public_path__ + "static/media/shuriken.2c3181f3.svg";